










import Vue from 'vue'
import Item2ColEl from '@/components/elements/Item2ColEl.vue'
import { ItemWorkingHoursElInterface } from '@/config/interfaces'

export default Vue.extend({
  name: 'ItemWorkingHoursEl',

  components: { Item2ColEl },

  props: {
    templateItemData: {
      type: Object as () => ItemWorkingHoursElInterface,
      required: true
    }
  }
})
